import { db } from './config';
import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc, query, orderBy } from 'firebase/firestore';

const COLLECTION_NAME = 'appointments';

// Save a new appointment
export const saveAppointment = async (appointmentData) => {
  try {
    const newAppointment = {
      ...appointmentData,
      status: 'pending',
      createdAt: new Date().toISOString()
    };
    
    const docRef = await addDoc(collection(db, COLLECTION_NAME), newAppointment);
    return { id: docRef.id, ...newAppointment };
  } catch (error) {
    console.error('Error saving appointment:', error);
    throw error;
  }
};

// Get all appointments
export const getAppointments = async () => {
  try {
    const appointmentsCollection = collection(db, COLLECTION_NAME);
    const appointmentsQuery = query(appointmentsCollection, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(appointmentsQuery);
    
    const appointments = [];
    querySnapshot.forEach((doc) => {
      appointments.push({ id: doc.id, ...doc.data() });
    });
    
    return appointments;
  } catch (error) {
    console.error('Error retrieving appointments:', error);
    return [];
  }
};

// Update appointment status
export const updateAppointmentStatus = async (id, status) => {
  try {
    const appointmentRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(appointmentRef, { 
      status,
      updatedAt: new Date().toISOString() 
    });
    
    // Return the updated appointment
    return { id, status };
  } catch (error) {
    console.error('Error updating appointment status:', error);
    throw error;
  }
};

// Delete an appointment
export const deleteAppointment = async (id) => {
  try {
    const appointmentRef = doc(db, COLLECTION_NAME, id);
    await deleteDoc(appointmentRef);
    return id;
  } catch (error) {
    console.error('Error deleting appointment:', error);
    throw error;
  }
};